import calcItemPriceArray from './calcItemPriceArray'
import {round} from 'lodash'

const calcItemPrice = (product, defaultTaxPercentage) => {
  const {totalPrice, productTax} = calcItemPriceArray(product, defaultTaxPercentage)
  return round(totalPrice, 2)
}

export default calcItemPrice
